// extracted by mini-css-extract-plugin
module.exports = {"chip":"styles_chip__8yv2D","agendaChip":"styles_agendaChip__DHsbU","agendaChipText":"styles_agendaChipText__1Fl6F"};